import { Injectable } from "@angular/core";
import { ShellDomainProvider } from "../utility/shell-domain.provider";
import { HttpHeaders, HttpClient } from "@angular/common/http";

@Injectable()
export class EcapCorSendMailService {

    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    constructor(private http: HttpClient) {
    }
    sendEmail(mailPayload): any {
        return this.http.post(ShellDomainProvider['api'].EmailService + '/MailCommand/SendEmail',
            mailPayload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    enqueueMail(mailPayload): any {
        return this.http.post(ShellDomainProvider['api'].EmailService + '/MailCommand/EnqueueMail',
            mailPayload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
}